import React from 'react';
import { Trans } from 'react-i18next';
import { useMutation } from 'react-query';

import { ToastVariant, useToastMessage } from '~/Hooks';
import { IEvent } from '~/Models/DTO/Event.model';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { extractErrorMessage } from '~/Helpers/Error.helper';
import { IBookingSummaryEvent } from '~/Models/DTO/Booking.models';
import { ICalendarEventBookings } from '~/Screens/Calendar/interfaces';

export const useFullDayActivityBookings = () => {
  const { showToast } = useToastMessage();

  const eventBookings = useMutation(
    REQUEST_ACTIONS.GET_NEXT_EVENTS,
    async (event: IEvent): Promise<ICalendarEventBookings> => {
      const bookingSummary = await requestReactQuery<IBookingSummaryEvent[]>({
        url: CORE_SERVICE_URLS.BOOKING_SUMMARY,
        data: { eventIds: [event.id] },
        config: { method: 'POST' },
      });
      return {
        eventHasBookings: !!bookingSummary?.[0].bookingsBooked,
      };
    },
    {
      onError: (errorObj: IErrorResponse) => {
        const message = extractErrorMessage(errorObj) as any;
        showToast(
          'Full day activity error',
          <Trans i18nKey={message?.key} defaults={message?.defaultMessage || message} />,
          ToastVariant.ERROR,
        );
      },
    },
  );

  return { eventBookings };
};
